<div class="modal-header" id="customer-modal-title">
    <h3 class="modal-title" id="modal-title" translate="NOTIFICATION_DETAILS_CRITICALITY_TITLE"></h3>
    <span class="close" (click)="closeModal()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form [formGroup]="criticalityForm">
        <fieldset formArrayName="formChildren">
            <div class="row mb-3">
                <label
                    class="col-form-label text-start"
                    for="statusInArrivalDropdown"
                    translate="NOTIFICATION_DETAILS_CRITICALITY_STATUS_LABEL"
                ></label>
                <pace-core-dropdown
                    id="statusInArrivalDropdown"
                    [parentForm]="formChildren"
                    [(model)]="model.statusInArrival"
                    (valueChange)="onCriticalityChange()"
                ></pace-core-dropdown>
            </div>
            @if (model.showWarning) {
                <div class="row mb-3">
                    <div class="alert alert-warning" role="alert">
                        <span
                            translate="NOTIFICATION_DETAILS_CRITICALITY_ALERT_MESSAGE"
                            [translateParams]="{
                                previousCriticality: model.notificationEffectStatus,
                                selectedCriticality: model.selectedEffectStatus,
                            }"
                        ></span>
                    </div>
                </div>
            }
            @if (model.showApprover) {
                <div class="row mb-3">
                    <label
                        class="col-form-label text-start"
                        for="approverInput"
                        translate="NOTIFICATION_DETAILS_CRITICALITY_APPROVER_LABEL"
                    ></label>
                    <pace-core-text-input
                        id="approverInput"
                        [parentForm]="formChildren"
                        [(model)]="model.approver"
                        [ariaLabel]="'NOTIFICATION_DETAILS_CRITICALITY_APPROVER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            }

            <div class="row mb-3">
                <label
                    class="col-form-label text-start"
                    for="downTimeStartDate"
                    translate="CONFIRMATION_EQUIPMENT_DOWN_TIME_START_LABEL"
                ></label>
                <pace-core-datetime-input
                    id="downTimeStartDate"
                    [(model)]="model.downTimeStartDateTime"
                    (valueChange)="model.setRecoveryDateTimeOptions()"
                    [parentForm]="formChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_DOWN_TIME_START_LABEL' | translate"
                ></pace-core-datetime-input>
            </div>

            <div class="row mb-3">
                <label
                    class="col-form-label text-start"
                    for="timeOfRecoveryDate"
                    translate="CONFIRMATION_EQUIPMENT_TIME_OF_RECOVERY_LABEL"
                ></label>
                <pace-core-datetime-input
                    id="timeOfRecoveryDate"
                    [(model)]="model.timeOfRecoveryDateTime"
                    [parentForm]="formChildren"
                    [ariaLabel]="'CONFIRMATION_EQUIPMENT_TIME_OF_RECOVERY_LABEL' | translate"
                ></pace-core-datetime-input>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer justify-content-between justify-content-md-end">
    <button
        class="btn btn-secondary"
        type="button"
        (click)="closeModal()"
        translate="NOTIFICATION_DETAILS_CRITICALITY_CANCEL_BUTTON_LABEL"
    ></button>
    <button
        class="btn btn-primary"
        type="button"
        [disabled]="isChangeDisabled()"
        (click)="updateCriticality()"
        translate="NOTIFICATION_DETAILS_CRITICALITY_SAVE_BUTTON_LABEL"
    ></button>
</div>
